import Permission from '@/components/system/Permission'
import Resource from '@/components/system/Resource'
import Role from '@/components/system/Role'
import User from '@/components/system/User'
import CycleSet from '@/components/system/CycleSet'
import SysLog from '@/components/log/SysLog'
import WechatMenu from '@/components/system/WechatMenu'

let system = [{
  path: '/sys/permission',
  name: 'Permission',
  component: Permission
},{
  path: '/sys/resource',
  name: 'Resource',
  component: Resource
},{
  path: '/sys/role',
  name: 'Role',
  component: Role
},{
  path: '/sys/user',
  name: 'User',
  component: User
},{
  path: '/sys/cycleSet',
  name: 'CycleSet',
  component: CycleSet
},{
  path: '/log/sysLog',
  name: 'SysLog',
  component: SysLog
},{
  path: '/sys/wechatMenu',
  name: 'WechatMenu',
  component: WechatMenu
}]

export default system



// WEBPACK FOOTER //
// ./src/router/system.js